import { Link, useLocation } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import useDocumentMeta from "@/hooks/useDocumentMeta";

export default function NotFound() {
  const location = useLocation();

  useDocumentMeta({
    title: "页面未找到 - 色虎影视",
    description: "你访问的页面不存在，可以返回色虎首页浏览热门影视推荐与影视资讯。",
    keywords: "色虎,404,页面未找到",
  });

  return (
    <SiteLayout>
      <div className="portal-container flex min-h-[62vh] flex-col items-center justify-center py-16 text-center">
        <p className="font-heading text-[80px] font-black leading-none text-background-300 md:text-[120px]">404</p>
        <h1 className="mt-4 font-heading text-xl font-bold text-foreground-950 md:text-2xl">这个页面走丢了</h1>
        <p className="mt-2 max-w-md text-sm leading-7 text-foreground-500">
          你访问的地址 <span className="rounded bg-background-100 px-1.5 py-0.5 text-foreground-700">{location.pathname}</span> 不存在，
          或者对应的内容已经调整。可以返回首页，或者从下面的入口继续浏览。
        </p>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
          <Link to="/" className="btn-primary">
            <i className="ri-home-4-line" aria-hidden="true" />
            返回首页
          </Link>
          <Link to="/category/movie" className="btn-ghost">
            浏览电影
          </Link>
          <Link to="/news" className="btn-ghost">
            影视资讯
          </Link>
        </div>
      </div>
    </SiteLayout>
  );
}